import script from "./courseResource.vue?vue&type=script&lang=ts&name=Resource&setup=true"
export * from "./courseResource.vue?vue&type=script&lang=ts&name=Resource&setup=true"

import "./courseResource.vue?vue&type=style&index=0&id=4ec36d6c&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ec36d6c"]])

export default __exports__